// extracted by mini-css-extract-plugin
export default {"portfolio":"Portfolio_portfolio__xjG0h","portfolio__container":"Portfolio_portfolio__container__CEOkL","portfolio__link":"Portfolio_portfolio__link__DioiP"};